//pullstate store

import { Store } from 'pullstate';

export const AppStore = new Store({
    user: null,
    userDoc: {
        ready: false,
        useMyData: true,
    },
    drawerWidth: 280,
    appBarHeight: 64,
    plans: null,
    clientReferenceId: null,
    highlightOn: false,
    memberships: [],
    accountModalOpen: false,
    signupsClosed: false,
    loadError: false, // account read failed — sign-in could not be completed
    accessEnded: false, // access period is over (wind-down cutoff)
});
